import { useEffect } from 'react'
import { UNSUBSCRIBED_BILLING_PATH } from '@/features/auth/subscription-state'
import { useNavigate } from 'react-router-dom'
import { Check } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAccountStore } from '@/stores/account-store'
import { setCobraIntent } from '@/storage/cobra-intent'

const PERKS = [
  'Full EDGE access — real-time data, scanner, charts, and more',
  'No cost to you — your Cobra Premier membership covers it',
  'No credit card required to activate',
]

/**
 * Branded Cobra Premier funnel. The advertised `/cobra` link lands here; arriving
 * IS the opt-in, so we set the sticky intent marker on mount (it survives register /
 * login / refresh). The marker is UX-only — the coupon is applied server-side and only
 * if the email is on the allowlist, so this page grants nothing on its own.
 */
export function CobraPage() {
  const navigate = useNavigate()
  const session = useAccountStore((s) => s.session)

  useEffect(() => {
    setCobraIntent()
  }, [])

  const primary = session
    ? { label: 'Activate Cobra Premier', to: UNSUBSCRIBED_BILLING_PATH }
    : { label: 'Create your free account', to: '/register' }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-amber-400">
            Cobra Premier
          </div>
          <h1 className="mt-2 text-3xl font-bold text-foreground">Free EDGE through Cobra</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            As a Cobra member, your EDGE subscription is 100% covered — free for as long as your
            Cobra Premier membership is active. Activate below to get started.
          </p>
        </div>

        <ul className="space-y-2 text-left">
          {PERKS.map((perk) => (
            <li key={perk} className="flex items-start gap-2 text-sm text-foreground">
              <Check size={16} className="mt-0.5 shrink-0 text-amber-400" />
              <span>{perk}</span>
            </li>
          ))}
        </ul>

        <div className="space-y-3">
          <Button className="w-full" onClick={() => navigate(primary.to)}>
            {primary.label}
          </Button>
          {!session && (
            <div>
              <button
                onClick={() => navigate('/login')}
                className="text-sm text-muted-foreground hover:text-foreground"
              >
                Already have an account? Sign in
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
